/**
 * Sticky notes.
 *
 * The scrap of paper on the monitor, not the filing cabinet. Notes — the
 * section with folders and search and a trash — is where a parent meeting
 * write-up goes. This is "Ellie's mum is collecting at 2" written on a square
 * that gets thrown away by Friday, and the two want opposite things from an
 * interface, which is why they are opposite things in the code.
 */
/**
 * The paper it is written on.
 *
 * Muted, because these sit on a dashboard that already has a theme and a
 * wall of neon squares would fight everything around them. Chosen to stay
 * readable with dark writing on them in every theme — the writing colour is
 * fixed rather than themed for exactly that reason.
 */
export const STICKY_COLORS = [
    { name: 'Butter', value: '#F6E6A8' },
    { name: 'Peach', value: '#F6D8C0' },
    { name: 'Rose', value: '#F2CFCF' },
    { name: 'Sage', value: '#D6E0C4' },
    { name: 'Sky', value: '#CFDDE8' },
    { name: 'Lilac', value: '#DED2E4' },
    { name: 'Sand', value: '#E7DCC9' },
];
/** How big one is on the board, and how much room the board needs. */
export const STICKY_SIZE = { width: 180, height: 150 };
/**
 * As many as are useful and not more.
 *
 * A wall of forty stickies is a wall nobody reads — at that point the thing
 * she needs is the Notes section, which has search in it.
 */
export const MAX_STICKIES = 40;
/** Keeps a dragged note on the board, whatever the pointer did. */
export function clampSticky(spot, board) {
    /*
     * A margin rather than the full width, so a note dragged to the right edge
     * keeps a grabbable strip on screen. Dropping one exactly on the boundary
     * and losing it behind the card's overflow is the failure this prevents.
     */
    const maxX = Math.max(0, board.width - STICKY_SIZE.width);
    const maxY = Math.max(0, board.height - STICKY_SIZE.height);
    return {
        x: Math.min(Math.max(0, Math.round(spot.x)), Math.round(maxX)),
        y: Math.min(Math.max(0, Math.round(spot.y)), Math.round(maxY)),
    };
}
//# sourceMappingURL=sticky.js.map